import React from 'react';

export function WalletDisabledIcon({ className, width = 30, height = 30 }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 30 30">
      <path
        fill="#99aab5"
        d="M4.5 5.25a3 3 0 0 0-3 3v13.5a3 3 0 0 0 3 3h21a3 3 0 0 0 3-3V8.25s0-3-3-3z"
      />
      <path fill="#292f33" d="M1.5 9h27v3.75h-27z" />
      <path fill="#f4f7f9" d="M4.5 15.75h21v4.5h-21z" />
      <path
        fill="#8899a6"
        d="M15.75 19.5c-1.277 0-1.756-.907-1.852-1.35-.41.03-.81.227-1.353.572-.574.365-1.224.778-2.045.778-.898 0-1.443-.506-1.5-1.5-.002-.042.029-.141.016-.141-1.394 0-2.402 1.32-2.411 1.334a.75.75 0 0 1-1.048.162.75.75 0 0 1-.161-1.049C5.453 18.227 6.833 16.5 9 16.5c1.453 0 1.536 1.031 1.559 1.416l.005.082c.364-.026.743-.266 1.177-.543.721-.457 1.615-1.028 2.813-.721.653.167.755.773.794 1.002.01.057.024.142.037.17.005 0 .11.068.433.097.615.056 1.29-.21 2.006-.49.74-.29 1.507-.59 2.333-.59 2.542 0 3.575 1.226 3.685 1.365a.75.75 0 1 1-1.181.924c-.018-.02-.698-.79-2.503-.79-.542 0-1.146.236-1.786.486-.757.297-1.825.592-2.622.592"
      />
    </svg>
  );
}
